var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoRebekah(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 662.25 652.18",
    width: 55,
    height: 55,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#003087;}.cls-2{fill:#c14991;}.cls-3,.cls-5{fill:none;stroke-width:20px;}.cls-3,.cls-4,.cls-5{stroke:#fff;stroke-miterlimit:10;}.cls-3{stroke-linecap:round;}.cls-4{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M763.22,367.39c-2.42,2.65-5,5.19-7.57,7.59Z",
    transform: "translate(-351.88 -60.23)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M393.31,374.81q-3.85-3.53-7.4-7.42Z",
    transform: "translate(-351.88 -60.23)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M797.26,277.05c0,35.26-13,67.16-34,90.23h0l-.08.09L755.65,375l-.11.1,0,0L574.57,556.82,393.52,375l0,0-.18-.17-7.4-7.42-.08-.09v0c-21-23.07-33.94-55-33.94-90.23,0-3.78.14-7.51.44-11.21,5.15-65.11,54.69-116.21,115.07-116.21,48.55,0,90.09,33,107.18,79.83,17.08-46.79,58.63-79.83,107.17-79.83,60.24,0,109.7,50.85,115,115.75Q797.27,271.16,797.26,277.05Z",
    transform: "translate(-351.88 -60.23)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M393.52,375l-.21-.21.18.17Z",
    transform: "translate(-351.88 -60.23)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M980,523q-3.62,4-7.53,7.55Z",
    transform: "translate(-351.88 -60.23)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M610.39,530.62c-2.67-2.44-5.24-5-7.7-7.73Z",
    transform: "translate(-351.88 -60.23)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1014.12,432.65c0,35.24-13,67.14-34,90.21v0L980,523l-7.53,7.55L791.43,712.41l-181-181.79-7.7-7.73c-21-23.07-34-55-34-90.24,0-70.37,51.72-127.42,115.52-127.42,48.54,0,90.09,33,107.18,79.83,17.08-46.8,58.63-79.83,107.17-79.83C962.4,305.23,1014.12,362.28,1014.12,432.65Z",
    transform: "translate(-351.88 -60.23)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M448.88,354.24,428,355.78a3.15,3.15,0,0,1-3.37-2.9l-3.78-51.28a44.39,44.39,0,0,1,41-47.54h0a44.4,44.4,0,0,1,47.54,41l3.78,51.28a3.15,3.15,0,0,1-2.9,3.36l-21.41,1.93",
    transform: "translate(-351.88 -60.23)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 346.56,
    cy: 179.74,
    r: 35.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M461.28,258.06s-17.66-127.19,36-164.83,85.08-17.75,85.08-17.75c4.9-.54,106,37.8,119.13,176.75",
    transform: "translate(-351.88 -60.23)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRebekah);
export default __webpack_public_path__ + "static/media/Logo-Rebekah.f74456582559e61606e989387b4f770f.svg";
export { ForwardRef as ReactComponent };